import * as React from 'react';
import { MiniCart, MiniCartActions } from '@invitae/physician-cart';
import { useCart } from './Cart.hooks.esm.js';

var SSRCompatibleCart = function (_a) {
    var classes = _a.classes;
    var goToSignInPage = useCart().goToSignInPage;
    var goToCartPage = function () {
        window.location.assign('/start-order/#/cart');
    };
    return (React.createElement(MiniCart, { className: classes === null || classes === void 0 ? void 0 : classes.shoppingCartIcon, handleCartClick: goToSignInPage },
        React.createElement(MiniCartActions, { proceedAction: goToCartPage })));
};

export { SSRCompatibleCart as default };
//# sourceMappingURL=Cart.esm.js.map
